import styled from 'styled-components';
import { mediaQuery } from '../../../utils/mediaQuery';

export const TitleSectionStyled = styled.p`
  font-size: 20px;
  font-family: Lato, sans-serif;
  color: #333333;
  margin: 0;
`;

export const TitleSectionConteinerStyled = styled.div`
  padding: 26px 24px 2px 26px;

  ${mediaQuery.mobileOnly(`
    padding: 12px 12px 9px 12px;
  `)}
`;
